import { Fragment } from 'react';
import './pages.css';
import Footer from './Footer';
import Product1 from "../images/phone2.jpg";
import home1 from "../images/contactus3.jpg";
const ContactUS =() => {
    return (
        <Fragment>
            <div className={ 'contact-content' }>
                <h2>Ready to work with us?</h2>
                <p>
                    If you are looking for a comprehensive solution for the management of your industrial surpluses, do not hesitate to 
                    contact us. We are confident that we can offer you a value proposition that meets your needs.
                </p>
                <img align="right" src={ home1 } className='avatar contact_img' alt='avatar' />
            </div>
            <Footer />
        </Fragment>
    )
};
export default ContactUS;
